import { render, staticRenderFns } from "./ModalSubstitutionArticle.vue?vue&type=template&id=44d7cbe2&"
import script from "./ModalSubstitutionArticle.vue?vue&type=script&lang=js&"
export * from "./ModalSubstitutionArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports